import DrawerMenu from 'app/components/common/DrawerMenu';
import { P } from 'app/components/common/Typography';
import React from 'react';
import { Drawer, NavBar, Button } from 'mui';
import SetProductDialog from '@setproduct-ui/core/Dialog/Dialog';
import { useAppDispatch, useAppSelector } from 'app/helpers/hooks';
import * as selectors from 'app/selectors/customer';
import { apiRequestUserCommand } from 'app/actions/customer';
import { push } from 'connected-react-router/immutable';
import { AvailableProducts } from 'app/constants/Products';
import { selectFurthestProductStepPath } from 'app/selectors/customer';

const Improvements = ({ setDialogOpen }) => {
  const dispatch = useAppDispatch();
  const intake = useAppSelector(selectors.selectCurrentIntake);
  const onSuccessActionCreator = (_, stateAfterSuccess) =>
    push(selectFurthestProductStepPath({ customer: stateAfterSuccess }, AvailableProducts.King));
  const action = apiRequestUserCommand({
    cmdType: 'answer_questions',
    params: { testosterone_energy_level: true, intake: intake.get('name') },
    context: {
      onSuccessActionCreator,
    },
  });
  const handleClose = () => {
    setDialogOpen(false);
    dispatch(action);
  };
  return (
    <div>
      <Drawer sideContent={<DrawerMenu loggedIn={false} />}>
        <NavBar />
        <div className="centered-content tyler">
          <div className="circle-progress mb76">
            <svg width="230" height="230">
              <circle className="circle-bg" cx="115" cy="115" r="105" strokeWidth="8" fill="none" />
              <circle className="circle-progress" cx="115" cy="115" r="105" strokeWidth="8" fill="none" />
            </svg>
            <div className="percentage">
              <div className="number">
                81<sup>%</sup>
              </div>
              <div className="text">
                of clients feel
                <br />
                improvements
              </div>
            </div>
          </div>
          <P className="interstitial_content">
            81% of Maximus patients report higher energy levels after just six months of treatment
          </P>
          <Button className="close" onClick={handleClose}>
            Next
          </Button>
        </div>
      </Drawer>
    </div>
  );
};

const ImprovementsPage = () => {
  const [dialogOpen, setDialogOpen] = React.useState(true);

  return (
    <SetProductDialog
      isOpen={dialogOpen}
      text={<Improvements setDialogOpen={setDialogOpen} />}
      showCloseModalIcon={false}
      dialogClassName="interstitial_container"
    />
  );
};

export default ImprovementsPage;
